export const getMenuState = (store) => store.menu;
export const getCurrentMenu = (store) => getMenuState(store).current;
